module.exports = __webpack_public_path__ + "static/img/10.5077b9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/10.png
// module id = KPNs
// module chunks = 0